<div class="toolbar">
  <span>
    <button matButton="text" (click)="backToOrganizationDetail()">
      <span>
        <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
        <label>Back To Organization</label>
      </span>
    </button>
  </span>
  <span class="spacer"></span>
  <span>
    <button matButton="text" (click)="newAddress()">
      <span>
        <mat-icon class="size-16">add</mat-icon>
        <label>New Address</label>
      </span>
    </button>
  </span>
</div>
<div class="addressesLayout">
  <div class="leftColumn">
    @if (addressesLoaded()) {
      <org-address-grid (addressSelected)="selectedAddress=$event"
      [addresses]="addresses()"></org-address-grid>
    }
  </div>
  <div class="rightColumn">
    @if (selectedAddress) {
      <org-address-detail (addressSaved)="refreshList()" [isEdit]="true"
      [personLogin]="personLogin" [address]="selectedAddress"></org-address-detail>
    }
  </div>
</div>

